/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_TitleInputs */

const en_gc_search_guides_gridcraft_vs_excel_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft vs Excel: Which Spreadsheet Fits Your Work?`)
};

const zh_gc_search_guides_gridcraft_vs_excel_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft vs Excel：哪款电子表格适合你的工作？`)
};

/**
* | output |
* | --- |
* | "GridCraft vs Excel: Which Spreadsheet Fits Your Work?" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_title(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_title(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_title as "gc.search_guides.gridcraft_vs_excel.title" }